import { LockOutlined } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import React from 'react';
import { LOCKED_FEATURE_TOOLTIP_COPY } from '../types';

export const LockedFeatureTooltip: React.FC = () => (
  <Tooltip title={LOCKED_FEATURE_TOOLTIP_COPY} arrow>
    <span
      tabIndex={0}
      data-testid="locked-feature-tooltip"
      aria-label="Locked feature"
      style={{ display: 'inline-flex' }}
    >
      <LockOutlined
        aria-hidden
        fontSize="small"
        sx={{ cursor: 'pointer', opacity: 0.6 }}
      />
    </span>
  </Tooltip>
);
